import { render, staticRenderFns } from "./CardAlert.vue?vue&type=template&id=161d13c8"
import script from "./CardAlert.vue?vue&type=script&lang=js"
export * from "./CardAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports